<template>
  <!-- 消耗品発送検索 -->
  <div id="AppRegularDisposablesSearch">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">消耗品発送 管理</label>
        </div>
      </div>
      <!--1行目 -->
      <div class="columns">
        <div class="paddingLeft">
          <b-button
            v-on:click="goDeliveryList"
            class="button is-primary has-text-centered btnMgt"
            icon-left="library-books"
            native-type="button"
          >
            <span class="chBtn">発送リスト</span>
          </b-button>
        </div>
        <div class="column is-8">
          <span class="chExp left">過去分を含めて消耗品(定期/非定期)の発送履歴を参照可能です。</span>
        </div>
      </div>
      <!--2行目 -->
      <div v-if="roleId===5||roleId===1" class="columns">
        <div class="paddingLeft">
          <b-button
            v-on:click="confirmAllCancelListDownload()"
            class="button is-primary has-text-centered btnMgt"
            icon-left="download"
            native-type="button"
          >
            <span class="chBtnCanel">
              <span style="vertical-align: bottom">
                全キャンセルリスト
                <br />
              </span>
              <span style="vertical-align: top">ダウンロード</span>
            </span>
          </b-button>
        </div>
        <div class="paddingLeft paddingTop">
          <b-field label="対象年月" labelPosition="on-border">
            <b-datepicker
              v-model="targetMonth"
              name="targetMonth"
              type="month"
              placeholder="対象年月"
              icon="calendar-today"
              :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
              :day-names="['日','月','火','水','木','金','土']"
            ></b-datepicker>
          </b-field>
        </div>
        <div class="column is-7">
          <span class="chExp left">対象年月の全キャンセルリストがダウンロード可能です。</span>
        </div>
      </div>
      <!--3行目 -->
      <div v-if="roleId===5||roleId===1" class="columns">
        <div class="paddingLeft">
          <b-button
            v-on:click="confirmNewCancelListDownload"
            class="button is-primary has-text-centered btnMgt"
            icon-left="download"
            native-type="button"
          >
            <span class="chBtnCanel">
              <span style="vertical-align: bottom">
                キャンセルリスト
                <br />
              </span>
              <span style="vertical-align: top">ダウンロード(新規追加分)</span>
            </span>
          </b-button>
        </div>
        <div class="column is-9">
          <span class="chExp left">{{ this.nextMonth }} 発送予定のキャンセルリストのうち、新規追加分がダウンロード可能です。</span>
        </div>
      </div>
      <!--4行目 -->
      <div v-if="roleId===5||roleId===1||roleId===6" class="columns">
        <div class="paddingLeft">
          <b-button
            v-on:click="confirmDemandForecastDownload"
            class="button is-primary has-text-centered btnMgt"
            icon-left="download"
            native-type="button"
          >
            <span class="chBtn">需要予測ダウンロード</span>
          </b-button>
        </div>
        <div class="column is-7">
          <span
            class="chExp left"
          >{{ this.nextMonth }} ～ {{ this.sixAfterMonth }} までの需要予測がダウンロード可能です。</span>
        </div>
      </div>
    </div>
    <!--検索条件 -->
    <div class="box" style="margin-left: 50px; margin-right: 50px;">
      <template :searchConditions="searchConditions">
        <div class="columns">
          <div class="column">
            <label class="searchTitle label">消耗品発送 検索</label>
          </div>
        </div>
        <!--1行目 -->
        <div class="columns">
          <div>
            <span class="chExp left paddingLeft">現在は、{{ this.fixMonth }}以降発送分の確定処理が可能です。</span>
            <br />
            <span
              v-if="cancelDateFlg"
              class="chExp left paddingLeft"
            >現在は、{{ this.nextMonth }}以降発送分のキャンセルが可能です。</span>
          </div>
        </div>
        <div class="column" />
        <!--1行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="患者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientCode"
                name="patientCode"
                data-vv-as="患者コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="患者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.patientName"
                name="patientName"
                data-vv-as="患者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="営業所コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.officeCode"
                name="officeCode"
                data-vv-as="営業所コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--2行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="品目コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productCode"
                name="productCode"
                data-vv-as="品目コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="品目名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.productName"
                name="productName"
                data-vv-as="品目名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="医療機関コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalCode"
                name="hospitalCode"
                data-vv-as="医療機関コード"
                type="text"
                maxlength="8"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--3行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="医療機関名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.hospitalName"
                name="hospitalName"
                data-vv-as="医療機関名"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者コード" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffCode"
                name="staffCode"
                data-vv-as="点検担当者コード"
                type="text"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="点検担当者名" labelPosition="on-border">
              <b-input
                v-model="searchConditions.staffName"
                name="staffName"
                data-vv-as="点検担当者名"
                type="text"
              ></b-input>
            </b-field>
          </div>
        </div>
        <!--4行目 -->
        <div class="columns">
          <div class="column is-one-third">
            <b-field label="ステータス" labelPosition="on-border" class="checkboxButtonField">
              <b-checkbox-button
                v-model="searchConditions.regularDisposablesStatusGroup"
                native-value="1"
              >確定</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.regularDisposablesStatusGroup"
                native-value="0"
              >未確定</b-checkbox-button>
              <b-checkbox-button
                v-model="searchConditions.regularDisposablesStatusGroup"
                native-value="2"
              >発送対象外</b-checkbox-button>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field label="消耗品発送月" labelPosition="on-border">
              <b-datepicker
                v-model="deliveryMonth"
                :min-date="minDate"
                name="deliveryMonth"
                type="month"
                placeholder="検索年月"
                icon="calendar-today"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                :day-names="['日','月','火','水','木','金','土']"
              ></b-datepicker>
            </b-field>
          </div>
        </div>
        <!-- 検索実行ボタン-->
        <div class="columns" style="text-align:center;">
          <div class="column">
            <b-button
              class="button"
              type="is-primary"
              icon-right="magnify"
              native-type="button"
              @click="search(searchConditions)"
            >検索する</b-button>
          </div>
        </div>
        <div class="columns" style="text-align:center;">
          <div class="column">
            <span style="color: red" v-if="isSearchConditionNull">検索条件を指定してください。</span>
            <span style="color: red" v-if="isSearchConditionAll">全件検索となる為、検索条件を絞り込んでください。</span>
          </div>
        </div>
      </template>
    </div>
    <!-- 検索結果 -->
    <div class="box" style="resultArea; margin-left: 50px; margin-right: 50px;">
      <regularDisposablesSearchResult
        ref="searchResult"
        v-bind:searchConditions="searchConditions"
      />
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import resultTemplate from "./AppRegularDisposablesSearchResult";
var data = [];
export default {
  name: "AppRegularDisposablesSearch",
  methods: {
    search: function(searchConditions) {
      if (
        this.isLength(this.searchConditions.patientCode) ||
        this.isLength(this.searchConditions.patientName) ||
        this.isLength(this.searchConditions.officeCode) ||
        this.isLength(this.searchConditions.productCode) ||
        this.isLength(this.searchConditions.productName) ||
        this.isLength(this.searchConditions.hospitalCode) ||
        this.isLength(this.searchConditions.hospitalName) ||
        this.isLength(this.searchConditions.staffCode) ||
        this.isLength(this.searchConditions.staffName) ||
        this.searchConditions.regularDisposablesStatusGroup.length > 0
      ) {
        console.log("検索条件あり");
        this.isSearchConditionNull = false;
        if (
          !this.isLength(this.searchConditions.patientCode) &&
          !this.isLength(this.searchConditions.patientName) &&
          !this.isLength(this.searchConditions.officeCode) &&
          !this.isLength(this.searchConditions.productCode) &&
          !this.isLength(this.searchConditions.productName) &&
          !this.isLength(this.searchConditions.hospitalCode) &&
          !this.isLength(this.searchConditions.hospitalName) &&
          !this.isLength(this.searchConditions.staffCode) &&
          !this.isLength(this.searchConditions.staffName)
        ) {
          if (
            this.isSearchAll([
              this.searchConditions.regularDisposablesStatusGroup.length,
              3
            ])
          ) {
            this.isSearchConditionAll = true;
            return;
          }
        }
        this.isSearchConditionAll = false;
        // 検索条件の整形
        if (this.deliveryMonth && !(typeof this.deliveryMonth == "string")) {
          this.searchConditions.deliveryMonth = this.formatMonth2(
            this.deliveryMonth
          );
        }
        // 検索実行
        this.$refs.searchResult.search(this.searchConditions);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
        this.isSearchConditionAll = false;
      }
    },
    goDeliveryList: function(data) {
      //発送リスト
      this.$router.push({
        name: "AppRegularDisposablesView",
        params: { deliveryMonth: this.deliveryMonth }
      });
    },
    confirmAllCancelListDownload: function() {
      //全キャンセルリストダウンロード
      this.targetMonthStr = this.targetMonth;
      if (this.targetMonthStr) {
        this.targetMonthStr = this.formatMonth2(this.targetMonthStr);
        this.$dialog.confirm({
          title: "全キャンセルリスト",
          message:
            this.targetMonthStr +
            " 月分のキャンセルリストを<br />ダウンロードします。よろしいですか？",
          confirmText: "ダウンロードする",
          cancelText: "キャンセル",
          type: "is-info",
          hasIcon: true,
          onConfirm: () => {
            // WebAPI Call
            var excuteApi = this.doAllCancelListDownload;
            var errorCallBack = this.downloadFileError;
            this.downloadApiCall(excuteApi, errorCallBack).then(() => {
              this.search();
            });
          }
        });
      } else {
        this.showErrorMessage("対象年月を選択してください。");
      }
    },
    doAllCancelListDownload: function(client) {
      var allFlg = true;
      return client.apis.apiInspection.downloadRegularDispoCancelFilePOST({
        body: {
          allFlg: allFlg,
          deliveryMonth: this.targetMonthStr
        }
      });
    },
    confirmNewCancelListDownload: function() {
      //キャンセルリスト(新規追加分)ダウンロード
      this.$dialog.confirm({
        title: "キャンセルリスト(新規追加分)",
        message:
          "キャンセルリスト(新規追加分)を<br />ダウンロードします。よろしいですか？",
        confirmText: "ダウンロードする",
        cancelText: "キャンセル",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          // WebAPI Call
          var excuteApi = this.doNewCancelListDownload;
          var errorCallBack = this.downloadFileError;
          this.downloadApiCall(excuteApi, errorCallBack).then(() => {
            this.search();
          });
        }
      });
    },
    doNewCancelListDownload: function(client) {
      var allFlg = false;
      return client.apis.apiInspection.downloadRegularDispoCancelFilePOST({
        body: {
          allFlg: allFlg,
          deliveryMonth: this.nextMonth
        }
      });
    },
    confirmDemandForecastDownload: function() {
      //需要予測ダウンロード
      this.$dialog.confirm({
        title: "需要予測ダウンロード",
        message: "需要予測をダウンロードします。<br />よろしいですか？",
        confirmText: "ダウンロードする",
        cancelText: "キャンセル",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          // WebAPI Call
          var excuteApi = this.downloadRegularDispoDemandForecastFilePOST;
          var errorCallBack = this.downloadFileError;
          this.downloadApiCall(excuteApi, errorCallBack);
        }
      });
    },
    downloadRegularDispoDemandForecastFilePOST: function(client) {
      return client.apis.apiInspection.downloadRegularDispoDemandForecastFilePOST();
    },
    downloadFileError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = JSON.parse(sessionStorage.getItem("userInfo")).srcRoleId;
    var searchConditions = {
      patientCode: "",
      patientName: "",
      officeCode: "",
      productCode: "",
      productName: "",
      hospitalCode: "",
      hospitalName: "",
      staffCode: "",
      staffName: "",
      deliveryMonth: "",
      regularDisposablesStatusGroup: []
    };
    var targetMonth;
    var targetMonthStr;
    //次月を取得（yyyy/MM）
    var now = new Date();
    now.setMonth(now.getMonth() + 1);
    now.setDate(1);
    var nextMonth = this.formatMonth2(now);
    //6ヶ月後の月を取得（yyyy/MM)
    now = new Date();
    now.setMonth(now.getMonth() + 6);
    now.setDate(1);
    var sixAfterMonth = this.formatMonth2(now);
    // 1-5⽇はシステム⽇付+1ヶ月、6⽇以降はシステム⽇付+2ヶ月を取得
    var deliveryMonth = this.getDeliveryMonthDate();
    var fixMonth = this.getDeliveryMonth();
    //cancelDateFlgは1-5日、月末前4日間はfalse
    var cancelDateFlg = false;
    now = new Date();
    var today = now.getDate();
    const lastCancelDay = this.getShoumouCancelRangeEndDay();
    if (5 < today && today <= lastCancelDay) {
      cancelDateFlg = true;
    } else {
      cancelDateFlg = false;
    }
    //今月の初日を取得
    var minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);
    minDate.setDate(1);

    if (this.$route.params["searchConditions"]) {
      searchConditions = this.$route.params["searchConditions"];
      if (
        typeof searchConditions.deliveryMonth == "string" &&
        searchConditions.deliveryMonth != ""
      ) {
        deliveryMonth = this.parseDateMonth(searchConditions.deliveryMonth);
      }
    } else {
      if (userInfo.roleId != 1 && userInfo.roleId != 2) {
        searchConditions.officeCode = userInfo.officeCode;
        searchConditions.staffCode = userInfo.staffCode;
        searchConditions.staffName = userInfo.fullName;
      }
    }
    return {
      searchConditions,
      isSearchConditionNull: false,
      isFixMessageActive: false,
      cancelDateFlg,
      userInfo,
      deliveryMonth,
      nextMonth,
      sixAfterMonth,
      fixMonth,
      minDate,
      targetMonth,
      targetMonthStr,
      roleId,
      isSearchConditionAll: false
    };
  },
  components: {
    regularDisposablesSearchResult: resultTemplate
  },
  watch: {},
  mounted: function() {
    // this.search();
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// 文字サイズ
.chExp {
  font-size: 18px;
}
.chBtn {
  font-size: 18px;
}
.chBtnCanel {
  font-size: 13px;
}

//ボタンサイズ
.btnMgt {
  height: 48px;
  width: 250px;
}

// 位置
.left {
  float: left;
}

.paddingLeft {
  padding-left: 12px;
}
.paddingTop {
  padding-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppRegularDisposablesSearch.vue